import { z } from 'zod'

export const restorePasswordSchema = z.object({
  email: z.string().min(5, 'Za krótki email').email('Niepoprawny email')
})

export type RestorePasswordProps = z.infer<typeof restorePasswordSchema>
